import React, { useContext, useEffect } from "react";
import { useMediaPredicate } from "react-media-hook";
import {
  Button,
  Icon,
  MenuItem,
  List,
  ListItem,
  Typography,
  DialogContent,
  DialogTitle,
  Dialog,
} from "@material-ui/core";
import { useState } from "react";
import { makeStyles } from "@material-ui/styles";
import { useSelector, useDispatch } from "react-redux";
import { switchTheme, switchThemeDefault } from "../../actions";
import { useTranslation } from "react-i18next";
import { MasterContext } from "../../context/master";

const useStyles = makeStyles((theme) => ({
  menuItem: {
    paddingRight: theme.spacing(4),
    paddingLeft: theme.spacing(4),
  },
  menuItemV2: {
    display: "flex",
    alignContent: "center",
    alignItems: "center",
    justifyContent: "center",
  },
  themeTypo: {
    marginLeft: 8,
  },
}));

const LanguageSelector = (props) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const dispatch = useDispatch();
  const context = useContext(MasterContext);
  const theme = useSelector((state) => state.theme);
  const [dialogOpen, setDialogOpen] = useState(false);
  const preferredTheme = useMediaPredicate("prefers-color-scheme: dark")
    ? "dark"
    : "light";

  const SwitchTheme = (data) => {
    const item = Object.fromEntries(
      Object.entries(JSON.parse(localStorage.getItem("persist:root")))
        .map((r) => r)
        .filter((r) => ["theme", "language"].includes(r[0]))
    );
    item.theme = JSON.stringify(data);
    var tmp = JSON.stringify(item);
    context.ChangeSavedPreferences(tmp).then((response) => {
      dispatch(switchTheme(data));
    });
  };

  return (
    <React.Fragment>
      <MenuItem
        style={{
          height: "76px",
        }}
        className={classes.menuItemV2}
        onClick={() => setDialogOpen(true)}
      >
        <Typography>{t("Switch Theme")}</Typography>
      </MenuItem>

      <Dialog open={dialogOpen}>
        <DialogTitle style={{ textAlign: "center" }}>
          {t("Switch Theme")}
        </DialogTitle>
        <DialogContent>
          <List>
            <ListItem>
              <Button
                variant="outlined"
                color="primary"
                size="large"
                fullWidth={true}
                startIcon={<Icon>brightness_5</Icon>}
                disabled={theme === "dark"}
                onClick={() => SwitchTheme("dark")}
              >
                {t("Switch to Dark Theme")}
              </Button>
            </ListItem>
            <ListItem>
              <Button
                variant="outlined"
                color="primary"
                size="large"
                fullWidth={true}
                startIcon={<Icon>brightness_4</Icon>}
                disabled={theme === "light"}
                onClick={() => SwitchTheme("light")}
              >
                {t("Switch to Light Theme")}
              </Button>
            </ListItem>
            <ListItem>
              <Button
                fullWidth={true}
                variant="outlined"
                color="primary"
                size="large"
                disabled={preferredTheme !== theme} 
                onClick={() => { SwitchTheme(preferredTheme)}}
              >
                {t("Switch to Default Theme")}
              </Button>
            </ListItem>
          </List>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
};

export default LanguageSelector;
